import type { SpeechEngine } from '@fos/shared/contracts/speech';
import { trpc } from '../../lib/trpc';

/**
 * Silnik mowy workspace'u i dostępność transkrypcji na serwerze (`voice.speechStatus`, Fala 10). Błąd albo brak
 * odpowiedzi = automatycznie bez serwera (tylko przeglądarka) — mikrofon nigdy nie blokuje pisania.
 */
export function useSpeechStatus(enabled = true): {
  engine: SpeechEngine;
  serverAvailable: boolean;
  serverMessage: string | null;
  simulated: boolean;
  /** odpowiedź (albo błąd) już jest — silnik ustalony (start dyktowania od razu po otwarciu czeka na to) */
  ready: boolean;
} {
  const q = trpc.voice.speechStatus.useQuery({}, { enabled, staleTime: 60_000, retry: false });
  const data = q.data;
  return {
    engine: data?.engine ?? 'auto',
    serverAvailable: data?.server.available ?? false,
    serverMessage: data?.server.message ?? null,
    simulated: data?.server.simulated ?? false,
    ready: q.isFetched || q.isError,
  };
}
